export enum SelectedEmailAction {
    New,
    Forward,
    Reply
}